/* eslint-disable import/no-duplicates */
/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import {
    PaymentElement,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';

const CreditForm = () => {

    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (elements == null) {
            return;
        }
        const { error: submitError } = await elements.submit();
        if (submitError) {
            setErrorMessage(submitError.message);
            return;
        }
        const res = await fetch('/create-intent', {
            method: 'POST',
        });

        const { client_secret: clientSecret } = await res.json();

        const { error } = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: {
                return_url: 'https://example.com/order/123/complete',
            },
        });

        if (error) {
            setErrorMessage(error.message);
        } 
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <PaymentElement />
                {errorMessage && <div>{errorMessage}</div>}
            </form>
        </>
    )
}

export default CreditForm


